import { createAction, props } from '@ngrx/store';

/** Remove a single error from the stack (its cross/times icon). */
const dismissError = createAction(
  '[Error Dialog] Dismiss error',
  props<{ id: number }>()
);

/** Remove every error at once (closing the dialog). */
const dismissAllErrors = createAction('[Error Dialog] Dismiss all errors');

export const ErrorDialogActions = {
  dismissError,
  dismissAllErrors,
};
